module.exports = __webpack_public_path__ + "c57c9896442f2bfe062cd91ca68c810b.jpg";